<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-select
                label="POP"
                v-model="current.pop.id"
                :items="pops"
                item-text="nome"
                item-value="id"
                outlined
                dense
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Código" v-model="current.codigo" outlined dense></v-text-field>
            </div>
            <div class="col-md-9 col-sm-1">
              <v-text-field label="Nome" v-model="current.nome" outlined dense></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <v-select label="Topologia" v-model="current.topologia" :items="topologia" outlined dense></v-select>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="CTO máximo" v-model="current.ctoMax" outlined dense></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="CTO ativas" v-model="current.ctoDone" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    pops: null,
    topologia: [
      { text: "Cascata", value: 1 },
      { text: "Estrela", value: 2 }
    ]
  }),
  created: function() {
    this.load();
    this.loadPOPs();
  },
  methods: {
    loadPOPs: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/pop/", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.pops = response.data;
        })
        .catch(function () {
          console.log("pop fail");
        });
    },
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/cdo" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("cdo fail");
        });
    },
    save: function() {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/cdo", this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("CDO cadastrado com sucesso!");
            router.push({ path: "/cdo" });
          });
      } else {
        api
          .put("/cdo/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("CDO atualizado com sucesso!");
            router.push({ path: "/cdo" });
          });
      }
    }
  }
};
</script>